import type { TeamProjectDto } from '@internal/scorecards-common';

/** Counts of failing checks per severity id. Only present severities appear as keys. */
export function failingCountsBySeverity(
  project: TeamProjectDto,
): Record<string, number> {
  const counts: Record<string, number> = {};
  for (const check of project.failingChecks) {
    counts[check.severity] = (counts[check.severity] ?? 0) + 1;
  }
  return counts;
}

export const passPct = (project: TeamProjectDto): number =>
  project.total ? Math.round((100 * project.passed) / project.total) : 0;

export function matchesSearch(project: TeamProjectDto, query: string): boolean {
  const q = query.trim().toLowerCase();
  if (!q) return true;
  return (
    project.projectName.toLowerCase().includes(q) ||
    (project.kind ?? '').toLowerCase().includes(q)
  );
}
